function CorrectMarks(selector) {
    var container = document.querySelector(selector || ".tag-role-playing");
    if (!container) return;
    
    var marks = container.querySelectorAll("mark");
    var regex = /^\{([^\}]+)\}(.*?)$/;
    for (mark of marks) {
        const html = mark.innerHTML;
        const match = html.match(regex);
        if (!match) continue;
        
        var markClass = match[1];
        var rest = match[2];
        mark.classList.add(markClass);
        mark.innerHTML = rest;
    }
}